import { render, staticRenderFns } from "./bannersLinks.vue?vue&type=template&id=bf687e40&scoped=true&"
import script from "./bannersLinks.vue?vue&type=script&lang=js&"
export * from "./bannersLinks.vue?vue&type=script&lang=js&"
import style0 from "./bannersLinks.vue?vue&type=style&index=0&id=bf687e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf687e40",
  null
  
)

export default component.exports